module.exports = __webpack_public_path__ + "static/media/32.7f797fe2.png";